export default __webpack_public_path__ + "static/assets/abcc6ff566f4c21e46c1c898490c2ccc.svg";